import { PopoverArrow } from "@radix-ui/react-popover"

import { installColorScheme } from "../../theme/install"
import { Button } from "../Button"
import { ButtonGroup } from "../ButtonGroup"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardHeaderActions,
  CardHeaderTitle,
} from "../Card"
import { IconButton } from "../IconButton"
import { Mask } from "../Mask"
import { Popover } from "../Popover"
import { Text } from "../Text"
import styles from "./Tour.module.css"
import { useTour } from "./useTour"

export function Tour() {
  const tour = useTour()

  return (
    <Mask
      selector={tour.step?.selector}
      show={tour.isActive && (tour.step?.showMask ?? true)}
      padding={tour.step?.padding ?? 10}
      radius={6}
    >
      {tour.step ? (
        <Popover
          open={tour.isActive}
          align={tour.step.align ?? "start"}
          side={tour.step.side ?? "right"}
          sideOffset={16}
          portalContainer={
            document.getElementById("demo-popover-portal") ?? undefined
          }
          anchor={
            <div
              style={{
                position: "absolute",
                inset: 0,
                pointerEvents: "none",
              }}
            />
          }
        >
          <div ref={installColorSchemeOnRef} className={styles.popoverContent}>
            <PopoverArrow className={styles.popoverArrow} />
            <Card
              color="grey3"
              variant="elevated"
              paddingInline={16}
              paddingBlock={16}
              sx={{ width: 240 }}
            >
              {tour.step?.title ? (
                <CardHeader>
                  <CardHeaderTitle variant="h4">
                    {tour.step.title}
                  </CardHeaderTitle>
                  <CardHeaderActions>
                    <IconButton
                      icon="close"
                      size="small"
                      onClick={() => tour.exit()}
                    />
                  </CardHeaderActions>
                </CardHeader>
              ) : null}
              {tour.step?.content ? (
                <CardContent>
                  {typeof tour.step.content === "string" ? (
                    <Text>{tour.step.content}</Text>
                  ) : (
                    tour.step.content
                  )}
                </CardContent>
              ) : null}
              <CardFooter>
                <ButtonGroup sx={{ flexGrow: 1 }}>
                  {tour.hasPrevStep ? (
                    <Button color="grey" onClick={() => tour.prev()}>
                      Back
                    </Button>
                  ) : (
                    <div />
                  )}
                  <div style={{ flexGrow: 1 }} />
                  {tour.hasNextStep && (tour.step.showNextButton ?? true) ? (
                    <Button onClick={() => tour.next()}>Next</Button>
                  ) : (
                    <div />
                  )}
                </ButtonGroup>
              </CardFooter>
            </Card>
          </div>
        </Popover>
      ) : null}
    </Mask>
  )
}

function installColorSchemeOnRef(element: HTMLElement | null) {
  if (element) installColorScheme(element, "dark")
}
